/**
 * Shared utilities for sessionStorage-backed caching with TTL support.
 */
export interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

export function readSessionCache<T>(key: string, ttlMs: number): CacheEntry<T> | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (parsed && parsed.data !== undefined && parsed.timestamp && (Date.now() - parsed.timestamp) < ttlMs) {
      return parsed;
    }
  } catch (error) {
    // Ignore cache errors
  }
  return null;
}

export function writeSessionCache<T>(key: string, data: T, timestamp: number): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify({ data, timestamp }));
  } catch (error) {
    // Ignore storage errors
  }
}
